module.exports = __webpack_public_path__ + "static/media/line.864f7938.PNG";